import { FunctionComponent, useState, useEffect } from "react";
import { Button } from "@rmwc/button";
import "@rmwc/button/styles";
import styles from "./Buttons.module.scss";

type ownProps = {
  text: string;
  style?: object;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: string;
  disabled?: boolean;
  className?: string;
  buttonType?: "button" | "submit" | "reset";
};

const styleType = {
  primary: {
    backgroundColor: "#3b82f6",
    borderColor: "#2e6da4",
  },
  success: {
    backgroundColor: "#12b24a",
    borderColor: "#12b24a",
  },
  info: {
    backgroundColor: "#5bc0de",
    borderColor: "#46b8da",
  },
  warning: {
    backgroundColor: "#f0ad4e",
    borderColor: "#eea236",
  },
  danger: {
    backgroundColor: "#d9534f",
    borderColor: "#d43f3a",
  },
};

const ButtonRound: FunctionComponent<ownProps> = (props) => {
  const {
    text,
    style,
    onClick,
    type,
    disabled,
    className = "",
    buttonType = "button",
  } = props;
  const [buttonStyleType, setButtonStyleType] = useState({
    backgroundColor: "#337ab7",
    borderColor: "#2e6da4",
  });

  useEffect(() => {
    if (type) {
      if (styleType[type]) {
        setButtonStyleType(styleType[type]);
      }else{
        setButtonStyleType({
          backgroundColor: type,
          borderColor: type,
        });
      }
    }
  }, []);

  return (
    <Button
      label={text}
      theme="secondary"
      raised
      className={`${styles.buttonRound} ${className}`}
      style={{ ...buttonStyleType, ...style }}
      onClick={onClick}
      disabled={!!disabled}
      type={buttonType}
    />
  );
};

const ButtonSquare: FunctionComponent<ownProps> = (props) => {
  const {
    text,
    style,
    onClick,
    type,
    disabled,
    className = "",
    buttonType = "button",
  } = props;
  const [buttonStyleType, setButtonStyleType] = useState({
    backgroundColor: "#337ab7",
    borderColor: "#2e6da4",
  });

  useEffect(() => {
    if (type) {
      if (styleType[type]) {
        setButtonStyleType(styleType[type]);
      }else{
        setButtonStyleType({
          backgroundColor: type,
          borderColor: type,
        });
      }
    }
  }, []);
  
  return (
    <Button
      label={text}
      theme="secondary"
      raised
      className={`${styles.buttonSquare} ${className}`}
      style={{ ...buttonStyleType, ...style }}
      onClick={onClick}
      disabled={!!disabled}
      type={buttonType}
    />
  );
};

export { ButtonRound, ButtonSquare, ButtonRound as default };
